/* Litterbox: show only the selected variant's photos in the Dawn 9 gallery.
   Map: media id -> "all", "none", a list of variant ids that may show it (filename snippet),
   or a variant's main photo id (older order-based snippet). Both snippet versions work.
   Runs in the same step as Dawn's own photo switch, so there is no flash. */
(function () {
  function getMap(sectionId) {
    var el = document.getElementById('LbMediaGroups-' + sectionId);
    if (!el) return null;
    if (el._lbMap) return el._lbMap;
    try { el._lbMap = JSON.parse(el.textContent); } catch (e) { el._lbMap = null; }
    return el._lbMap;
  }

  function featuredIdFor(sectionId, variantId) {
    var picker = document.querySelector('variant-selects[data-section="' + sectionId + '"], variant-radios[data-section="' + sectionId + '"]');
    if (!picker) return '';
    if (picker.currentVariant && String(picker.currentVariant.id) === String(variantId)) {
      return picker.currentVariant.featured_media ? String(picker.currentVariant.featured_media.id) : '';
    }
    var json = picker.querySelector('script[type="application/json"]');
    try {
      var list = json ? JSON.parse(json.textContent) : [];
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].id) === String(variantId)) return list[i].featured_media ? String(list[i].featured_media.id) : '';
      }
    } catch (e) {}
    return '';
  }

  function matches(group, vid, fid) {
    if (Array.isArray(group)) return group.map(String).indexOf(vid) !== -1;
    return fid !== '' && String(group) === fid; // older snippet: group = main photo id
  }

  function apply(sectionId, variantId) {
    var map = getMap(sectionId);
    if (!map || !variantId) return;
    var vid = String(variantId);
    var fid = featuredIdFor(sectionId, variantId);
    var keys = Object.keys(map);

    // If no photo is tied to this variant, show everything except hidden ones.
    var hasOwn = keys.some(function (k) {
      var g = map[k];
      return g !== 'all' && g !== 'none' && matches(g, vid, fid);
    });

    function shouldShow(mediaId) {
      var group = map[mediaId];
      if (group === undefined || group === 'all') return true;
      if (group === 'none') return false;
      if (!hasOwn) return true;
      return matches(group, vid, fid);
    }

    var prefix = sectionId + '-';
    document.querySelectorAll('[id^="MediaGallery-' + sectionId + '"]').forEach(function (gallery) {
      // Safety net: hold the gallery's height until the next frame.
      var h = gallery.offsetHeight;
      if (h > 0) {
        gallery.style.minHeight = h + 'px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { gallery.style.minHeight = ''; });
        });
      }

      // Main photos: the active one (Dawn's current photo) is never hidden.
      gallery.querySelectorAll('li[data-media-id^="' + prefix + '"]').forEach(function (li) {
        var show = li.classList.contains('is-active') || shouldShow(li.dataset.mediaId.slice(prefix.length));
        li.classList.toggle('hidden', !show);
      });
      // Thumbnails: the current one is never hidden.
      gallery.querySelectorAll('li[data-target^="' + prefix + '"]').forEach(function (li) {
        var btn = li.querySelector('button');
        var current = btn && btn.getAttribute('aria-current') === 'true';
        li.classList.toggle('hidden', !(current || shouldShow(li.dataset.target.slice(prefix.length))));
      });
      gallery.querySelectorAll('slider-component').forEach(function (slider) {
        if (typeof slider.resetPages === 'function') {
          if (slider.slider) slider.slider.scrollTo({ left: 0 });
          slider.resetPages();
        }
      });
    });

    // Zoom modal
    var modal = document.querySelector('#ProductModal-' + sectionId + ' .product-media-modal__content');
    if (modal) {
      modal.querySelectorAll('[data-media-id]').forEach(function (item) {
        item.classList.toggle('hidden', !shouldShow(item.dataset.mediaId));
      });
    }
  }

  // Run our filter right after Dawn's updateMedia, in the same task (before the browser paints).
  // variant-radios extends variant-selects in Dawn 9, so wrapping one covers both.
  function wrapDawn() {
    var VS = window.customElements && customElements.get('variant-selects');
    if (!VS || VS.prototype._lbWrapped) return !!VS;
    var original = VS.prototype.updateMedia;
    VS.prototype.updateMedia = function () {
      var result = original.apply(this, arguments);
      try {
        if (this.currentVariant && getMap(this.dataset.section)) apply(this.dataset.section, this.currentVariant.id);
      } catch (e) { /* never break Dawn */ }
      return result;
    };
    VS.prototype._lbWrapped = true;
    return true;
  }

  window.lbInitMediaGroups = function (sectionId, initialVariantId) {
    if (!getMap(sectionId)) return;
    apply(sectionId, initialVariantId);
    if (wrapDawn()) return;
    // Fallback if Dawn's picker isn't found: run after the change.
    document.addEventListener('change', function (event) {
      var picker = event.target.closest('variant-selects, variant-radios');
      if (!picker || picker.dataset.section !== sectionId) return;
      setTimeout(function () {
        var input = document.querySelector('#product-form-' + sectionId + ' input[name="id"]');
        if (input) apply(sectionId, input.value);
      }, 0);
    });
  };
})();